// Analytics tracking via raw fetch to PostgREST.
// Avoids pulling the ~50 KB Supabase JS client into the landing-page runtime
// (auth-js, realtime-js, storage-js, postgrest-js, phoenix). The anon key is
// public and the events table accepts anonymous inserts via RLS.

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;
const EVENTS_ENDPOINT = `${SUPABASE_URL}/rest/v1/events`;

const SESSION_KEY = "lcs_session_id";

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "no-session";
  }
}

function detectDevice(): string {
  const ua = navigator.userAgent;
  if (/Tablet|iPad/i.test(ua)) return "tablet";
  if (/Mobi|Android|iPhone/i.test(ua)) return "mobile";
  return "desktop";
}

function baseContext() {
  return {
    page_path: window.location.pathname,
    referrer: document.referrer || null,
    user_agent: navigator.userAgent,
    device_type: detectDevice(),
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    session_id: getSessionId(),
  };
}

async function insertEvent(row: Record<string, unknown>) {
  try {
    await fetch(EVENTS_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
        Prefer: "return=minimal",
      },
      body: JSON.stringify(row),
      keepalive: true,
    });
  } catch (e) {
    console.warn("event insert failed", e);
  }
}

export async function trackPageView() {
  await insertEvent({ event_type: "page_view", ...baseContext() });
}

export async function trackOutboundClick(url: string, label: string) {
  let destination = url;
  try {
    destination = new URL(url).hostname;
  } catch {
    /* noop */
  }
  await insertEvent({
    event_type: "outbound_click",
    destination,
    destination_label: label,
    ...baseContext(),
  });
}
